module.exports = __webpack_public_path__ + "img/snowboard.7f6bb123.svg";